__turbopack_context__.v({
  "clockColon": "countdown-module-scss-module__Jd-Kbq__clockColon",
  "clockColonFlashSale": "countdown-module-scss-module__Jd-Kbq__clockColonFlashSale",
  "clockDigit": "countdown-module-scss-module__Jd-Kbq__clockDigit",
  "timerIcon": "countdown-module-scss-module__Jd-Kbq__timerIcon",
});
